export default function isweixin() {
  const ua = navigator.userAgent;
  return /\bMicroMessenger\/([\d.]+)/.test(ua);
}
